import { getClientId } from 'src/services/utils';

import { Client } from '../api-client';

const getChaterWiseContentsUrl = (subjectId: string, programId: string) =>
  `v1/programs/${programId}/subjects/${subjectId}/chapters/chapter-wise-content`;

const sendVideoStatsUrl = () => 'v3' + '/video-stats/save-stats';

const contentRelatedIdsFetcher = (contentId: string) => `v2/programs/contents/${contentId}`;

const contentDetailsUrl = () => 'v2/programs/contents';

const getChaptersUrl = (subjectId: string, programId: string, version: string) =>
  `${version}/programs/${programId}/subjects/${subjectId}/chapters`;

const getChaptersSuggestiveSearchUrl = (subjectId: string, programId: string) =>
  `v1/programs/${programId}/subjects/${subjectId}/chapters/search`;

export const subjectsFetcher = ({ queryKey, pageParam = 1 }: any) => {
  const { programId } = queryKey[1];
  const params: any = {
    page: pageParam,
  };
  if (queryKey[1]['limit']) {
    params['limit'] = queryKey[1]['limit'];
  }
  return Client.get(`v1/programs/${programId}/subjects`, {
    params,
  }).then((r: any) => {
    return {
      ...r,
      page: pageParam,
    };
  });
};

export const sendVideoStats = (stats: any) => {
  return Client.post(sendVideoStatsUrl(), stats).then((res: any) => {
    res?.data;
  });
};
export const chapterFetchers = ({ queryKey, pageParam = 1 }: any) => {
  // const params: any = {
  //   page: pageParam
  // };
  const { subjectId, programId, version } = queryKey[1];
  let { params } = queryKey[1];
  params = { ...params, page: pageParam };

  if (queryKey[1]['limit']) {
    params['limit'] = queryKey[1]['limit'];
  }
  //
  return Client.get(getChaptersUrl(subjectId, programId, version), {
    params,
  }).then((r: any) => {
    return {
      ...r,
      page: pageParam,
    };
  });
};
export const videoContentFetcher = ({ queryKey, pageParam = 1 }: any) => {
  const params: any = {
    page: pageParam,
  };
  if (queryKey[1]['limit']) {
    params['limit'] = queryKey[1]['limit'];
  }
  //
  return Client.get(
    'v1/programs/complete-programe-256787/subjects/xii-physics-iit-jee-mains-and-neet-114751/chapters/electric-charges-and-fields-711586/topics/video-lectures-595704/contents?page=1',
    {
      params,
    },
  ).then((r: any) => {
    return {
      ...r,
      page: pageParam,
    };
  });
};
export const conceptContentFetcher = ({ queryKey, pageParam = 1 }: any) => {
  const params: any = {
    page: pageParam,
  };
  if (queryKey[1]['limit']) {
    params['limit'] = queryKey[1]['limit'];
  }
  //
  return Client.get(
    'v1/programs/complete-programe-256787/subjects/xii-physics-iit-jee-mains-and-neet-114751/chapters/electric-charges-and-fields-711586/topics/concepts-notes-022199/contents?page=1',
    {
      params,
    },
  ).then((r: any) => {
    return {
      ...r,
      page: pageParam,
    };
  });
};
export const assignmentContentFetcher = ({ queryKey, pageParam = 1 }: any) => {
  const params: any = {
    page: pageParam,
  };
  if (queryKey[1]['limit']) {
    params['limit'] = queryKey[1]['limit'];
  }
  //
  return Client.get(
    'v1/programs/complete-programe-256787/subjects/xii-physics-iit-jee-mains-and-neet-114751/chapters/electric-charges-and-fields-711586/topics/assignments-357876/contents?page=1',
    {
      params,
    },
  ).then((r: any) => {
    return {
      ...r,
      page: pageParam,
    };
  });
};

export const webConfigFetcher = ({}: any) => {
  return Client.get(
    `v1/web-preference/${getClientId()}?type=banner,videoGallery,testimonials&mode=nested`,
    {},
  ).then((r: any) => r?.data);
};

export const chapterWiseContentFetcher = ({ queryKey, pageParam = 1 }: any) => {
  const { subjectId, programId } = queryKey[1];
  let params = queryKey[1].params;
  params = { ...params, page: pageParam };
  return Client.get(getChaterWiseContentsUrl(subjectId, programId), {
    params,
  }).then((r: any) => {
    return {
      ...r,
      page: pageParam,
    };
  });
};

export const chapterSuggestiveSearchFetcher = ({ queryKey, pageParam = 1 }: any) => {
  const { subjectId, programId, params } = queryKey[1];

  return Client.get(getChaptersSuggestiveSearchUrl(subjectId, programId), {
    params,
  });
};

export const contentRelatedIds = ({ queryKey }: any) => {
  console.log('>>>>QUERY KEY', queryKey);
  const { contentId } = queryKey[1];
  return Client.get(contentRelatedIdsFetcher(contentId));
};

export const contentDetailsFetcher = ({ queryKey }: any) => {
  const { contentId, params } = queryKey[1];
  console.log('PARAMS>>', contentId, params);
  return Client.get(contentDetailsUrl(), { params });
};

export class SaveVideoStatsModal {
  batchId: string;
  batchSubjectId: string;
  chapterId: string;
  isComplete: boolean;
  lastWatchedPointInSec: number;
  programId: string;
  subTopicId: string;
  subjectId: string;
  topicId: string;
  type: string;
  typeId: string;
  userId: string;
  videoId: string;
  videoLength: number;
  tagId?: string;
  watchSessions: Array<WatchSessionsModal> = [];
  constructor(props: any) {
    props = props || '';
    this.batchId = props.batchId || '';
    this.batchSubjectId = props.batchSubjectId || '';
    this.chapterId = props.chapterId || '';
    this.isComplete = props.isComplete || false;
    this.lastWatchedPointInSec = props.lastWatchedPointInSec || 0;
    this.programId = props.programId || '';
    this.subTopicId = '';
    this.subjectId = props.subjectId || '';
    this.topicId = props.topicId || '';
    this.type = props.type || '';
    this.typeId = props.typeId || '';
    this.userId = props.userId || '';
    this.videoId = props.videoId || '';
    this.tagId = props.tagId || '';
    this.videoLength = props.videoLength || 0;
    if (props.watchSessions) {
      props.watchSessions.forEach((item: any) =>
        this.watchSessions.push(new WatchSessionsModal(item)),
      );
    } else {
      this.watchSessions = [];
    }
  }
}

export class WatchSessionsModal {
  deviceType: string;
  medium: string;
  isLive: boolean;
  videoType: string;
  clientVersion: number;
  watchStats: Array<WatchStatsModal> = [];
  constructor(props: any) {
    this.isLive = props.isLive || false;
    this.videoType = props.videoType || '';
    this.clientVersion = props.clientVersion || 0;
    props = props || {};
    this.deviceType = props.deviceType || 'Desktop';
    this.medium = props.medium || 'Web';
    if (props.watchStats) {
      props.watchStats.forEach((item: any) => this.watchStats.push(new WatchStatsModal(item)));
    } else {
      this.watchStats = [];
    }
  }
}

export class WatchStatsModal {
  endTime: number;
  endTimeTimestamp: number;
  startTime: number;
  startTimeTimestamp: number;
  constructor(props: any) {
    props = props || {};
    this.endTime = props.endTime || 0;
    this.endTimeTimestamp = props.endTimeTimestamp || 0;
    this.startTime = props.startTime || 0;
    this.startTimeTimestamp = props.startTimeTimestamp || 0;
  }
}
